import React, { useEffect, useState } from "react";
import { PageHeader, Card, Tag, fmt } from "../components/UI";
import DataTable from "../components/DataTable";
import { Bell, Clock, Send } from "lucide-react";
import api, { formatError } from "../lib/api";

export default function NonServicedAlerts() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/alerts/non-serviced-orders"); setItems(data); })(); }, []);

  async function nudge(physio_mobile) {
    try {
      await api.post("/whatsapp/send", { to: physio_mobile, text: "Hi! Your CBC order is awaiting delivery confirmation. Please coordinate with your DSE to validate." });
      alert("Reminder sent via WhatsApp.");
    } catch (e) { alert(formatError(e)); }
  }

  const columns = [
    { key: "order_ref", label: "Order #", filter: "text", render: (r) => <span className="font-mono text-[11px]">{r.order_ref || r.id?.slice(0, 10)}</span> },
    { key: "physio_name", label: "Physio", filter: "text" },
    { key: "physio_mobile", label: "Mobile", filter: "text", render: (r) => <span className="font-mono text-[11px]">{r.physio_mobile}</span> },
    { key: "physio_city", label: "City", filter: "text" },
    { key: "points", label: "Points pending", filter: "range", align: "right", render: (r) => fmt(r.points) },
    { key: "age_hours", label: "Age", filter: "range", align: "right",
      render: (r) => <Tag tone={r.age_hours > 96 ? "rose" : "amber"}><Clock size={11} /> {r.age_hours}h</Tag> },
    { key: "at", label: "Placed", render: (r) => new Date(r.at).toLocaleString() },
    { key: "actions", label: "", sortable: false, align: "right",
      render: (r) => <button onClick={(e) => { e.stopPropagation(); nudge(r.physio_mobile); }} className="text-teal-700 hover:underline text-[12px] inline-flex items-center gap-1"><Send size={11} /> WhatsApp nudge</button> },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        kicker="Operations"
        title="48-Hour Validation Reminders"
        subtitle="Every order sitting in Pending state for more than 48 hours appears here. Trigger a WhatsApp nudge to the physio with a single click."
        testId="alerts-page"
      />
      <Card>
        {items.length === 0 ? (
          <div className="text-center py-10">
            <Bell size={24} className="mx-auto text-emerald-600 mb-2" />
            <p className="text-slate-600 text-[13px]">All orders are within the 48-hour SLA. ✨</p>
          </div>
        ) : (
          <DataTable columns={columns} data={items} rowKey="id"
            searchableKeys={["physio_name", "physio_mobile", "physio_city", "order_ref"]}
            exportFilename="cbc-non-serviced" testIdPrefix="alerts"
            initialSort={{ key: "age_hours", dir: "desc" }} />
        )}
      </Card>
    </div>
  );
}
